import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { ColorVariant, getRecipeColor, colors, FooterCell, Typography } from '@ui-components/neo.tax';
import { Cell } from 'react-table';

import { transientPropOptions } from '@neo.tax/shared/third-parties';

import { NavLinkTo } from '../navigate';

const condensedRowClassName = css({ paddingTop: '0.5rem', paddingBottom: '0.5rem', height: 37 });
const selectedRowClassName = css({ backgroundColor: colors.gray[200], color: colors.gray[900] });
const unselectedRowClassName = css({ backgroundColor: colors.white, color: colors.gray[500] });
const alternatingRowClassName = css({ backgroundColor: colors.gray[50], color: colors.gray[500] });

export const customCellClassNames = <T extends object>(cell: Cell<T>): Record<string, boolean>[] => [
  {
    [condensedRowClassName]: true,
    [selectedRowClassName]: cell.row.isSelected,
    [unselectedRowClassName]: !cell.row.isSelected && cell.row.index % 2 === 0,
    [alternatingRowClassName]: !cell.row.isSelected && cell.row.index % 2 === 1,
  },
];

export const FooterCellStyled = styled(FooterCell)({
  fontSize: '0.75rem',
});

type ProjectLeftBarProps = {
  $isClicked?: boolean;
  $variant: ColorVariant;
};
export const ProjectLeftBar = styled.div<ProjectLeftBarProps>(({ $isClicked, $variant }) => ({
  height: '2.5rem',
  position: 'absolute',
  left: 0,
  width: $isClicked ? '0.25rem' : 0,
  backgroundColor: getRecipeColor($variant, 'colorBg').bg,
}));

type ProjectNameProps = {
  $variant: ColorVariant;
};
export const ProjectName = styled(
  NavLinkTo,
  transientPropOptions,
)<ProjectNameProps>(({ $variant }) => ({
  display: 'block',
  textOverflow: 'ellipsis',
  textDecoration: 'underline',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: 500,
  color: getRecipeColor($variant, 'whiteBg').text,
}));

/**
 * Certain cells that should have right aligned text cannot because the parent element is owned by the `Table` component
 * which is using `style={{ display: 'flex' }}` and therefore cannot be easily modified. Easiest workarounds are to wrap
 * in another component like `<Stack fullWidth>` or style it here and adjust the width or flex-grow.
 */
export const TypographyFullWidth = styled(Typography)({
  width: '100%',
});
